import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FindOptions } from 'api';
import { MaterialCategoryApi } from 'api/materialCategory';

export const filterMaterialCategory = createAsyncThunk(
  'materialCategory/filterMaterialCategory',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await MaterialCategoryApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findMaterialCategory = createAsyncThunk(
  'materialCategory/findMaterialSubCategory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await MaterialCategoryApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMaterialCategory = createAsyncThunk(
  'materialCategory/createMaterialCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await MaterialCategoryApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface MaterialCategorySate {
  list: Array<any>;
  listAll: Array<any>;
  materialSubCategoriesHash: any;
}

const initialState: MaterialCategorySate = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả các danh mục',
    },
  ],
  materialSubCategoriesHash: {},
};

const materialCategorySlice = createSlice({
  name: 'materialCategory',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findMaterialCategory.fulfilled, (state, action) => {
      const { data } = action.payload;

      (data || []).forEach((e: any) => {
        const materialSubcategories = e.materialSubcategories?.map(
          (item: any) => {
            return {
              ...item,
              key: item.id,
              value: item.id,
            };
          }
        );

        state.materialSubCategoriesHash[e.id] = materialSubcategories;
      });

      const newData = (data || []).map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;

      state.listAll = [
        {
          key: 'all',
          value: 'all',
          name: 'Tất cả các danh mục',
        },
        ...newData,
      ];
    });
  },
});

const { reducer: materialCategoryReducer } = materialCategorySlice;

export default materialCategoryReducer;
